/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cash': {
    width: 23,
    height: 21,
    viewBox: '0 0 23 21',
    data: '<path pid="0" _fill="#008cff" d="M20.745 3.06a2.261 2.261 0 012.26 2.259v13.495a2.261 2.261 0 01-2.26 2.259H2.683a2.261 2.261 0 01-2.26-2.26V2.308a2.261 2.261 0 012.26-2.26h15.803a2.261 2.261 0 012.26 2.26zM2.683 1.554a.754.754 0 000 1.506h16.556v-.753a.754.754 0 00-.753-.753zm18.062 18.013a.754.754 0 00.753-.753v-4.236h-7.325a2.639 2.639 0 01-2.635-2.636 2.639 2.639 0 012.635-2.635h7.325V5.319a.754.754 0 00-.753-.753H2.683a2.24 2.24 0 01-.753-.13v14.378c0 .415.338.753.753.753zm.753-8.754h-4.947a2.619 2.619 0 01.002 2.259h4.945zm-8.454 1.13a1.131 1.131 0 001.932.797 1.13 1.13 0 10-1.932-.798z"/>'
  }
})
